var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m5 3h14c1.105 0 2 .895 2 2v14c0 1.105-.895 2-2 2h-14c-1.105 0-2-.895-2-2v-14c0-1.105.895-2 2-2zm1.477 14h2.523v-7h-2.523zm1.217-8.283c-.771 0-1.286-.514-1.286-1.2s.514-1.2 1.371-1.2c.771 0 1.286.514 1.286 1.2s-.514 1.2-1.371 1.2zm7.864 8.283h2.442v-3.826c0-2.197-.977-3.174-2.198-3.174s-1.872.407-2.197.977v-.977h-2.523v7h2.523v-3.826c0-1.139.814-1.302 1.058-1.302s.895.244.895 1.302z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
export default SvgLinkedInreact;